import React, { useEffect, useState } from 'react'
import { apiUrls } from 'constants/apiUrls';
import { Alert, Button, Col, Form, Row } from 'react-bootstrap'
import { BiPlus } from 'react-icons/bi';
import { BsX } from 'react-icons/bs';
import { toast } from 'react-toastify';
import { invoiceService } from 'services/invoiceService';
import DatePicker from 'react-datepicker';
import { allowNumber, allowNumberDecimal } from 'utils/inputValidator';
import ProgressLoader from 'components/Loader/ProgressLoader';
import { ddMMyyyy } from 'utils/dateFormatter';

const InvoiceItemForm = ({ id, customerId, invoiceId, onSave, onCancel }) => {
    const [isLoader, setIsLoader] = useState(false);
    const [isEditForm, setIsEditForm] = useState();
    const [message, setMessage] = useState();
    const [invoiceItem, setInvoiceItem] = useState({
        id: id,
        customerId: customerId,
        invoiceId: invoiceId,
        itemDate: new Date(),
        challanNo: '',
        itemName: '',
        hsnCode: null,
        quantity: '',
        unitPrice: '',
        itemAmount: '',
        isActive: true
    });

    useEffect(() => {
        setIsEditForm(() => (id ? true : false))
        if (id > 0) {
            setIsLoader(true);
            invoiceService.getInvoiceItem(apiUrls.getInvoiceItem(id)).then((res) => {
                setIsLoader(false);
                setInvoiceItem(res)
            }).catch((err) => setIsLoader(false));
        }
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "quantity" && !allowNumber(e.target.value)) { return; }
        if (name === "challanNo" && !allowNumberDecimal(e.target.value)) { return; }
        if (name === "unitPrice" && !allowNumberDecimal(e.target.value)) { return; }

        setInvoiceItem((preValue) => ({
            ...preValue, [name]: (type === 'checkbox' ? checked : value)
        }));

        if (name === "hsnCode") {
            let hsnCode = (value > 0 ? value : null);
            setInvoiceItem((preValue) => ({
                ...preValue, "hsnCode": hsnCode
            }));
        }

        if (name === 'quantity' || name === 'unitPrice') {
            invoiceItem.itemAmount = 0;
            let quantity = (name === 'quantity' ? value : invoiceItem.quantity);
            let unitPrice = (name === 'unitPrice' ? value : invoiceItem.unitPrice);

            if (quantity > 0 && unitPrice > 0)
                invoiceItem.itemAmount = (quantity * unitPrice)

            setInvoiceItem((preValue) => ({
                ...preValue, "itemAmount": invoiceItem.itemAmount
            }));
        }
    }

    const setItemDate = (value) => {
        setInvoiceItem((preValue) => ({
            ...preValue, "itemDate": value
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            setIsLoader(true);
            if (isEditForm) {
                invoiceService.updateInvoiceItem(apiUrls.updateInvoiceItem(id), invoiceItem).then((res) => {
                    setIsLoader(false);
                    if (res === true) {
                        toast.success("Invoice item updated successfully!");
                        onSave();
                    }
                }).catch((err) => setIsLoader(false));
            } else {
                invoiceService.addInvoiceItem(apiUrls.addInvoiceItem(), invoiceItem).then((res) => {
                    setIsLoader(false);
                    if (res === true) {
                        toast.success("Invoice item added successfully!");
                        onSave();
                    }
                }).catch((err) => setIsLoader(false));
            }
        }
    }

    const validateForm = () => {
        setMessage();
        if (!invoiceItem.customerId
            || !invoiceItem.itemDate
            || !invoiceItem.challanNo
            || !invoiceItem.itemName
            || !invoiceItem.quantity
            || !invoiceItem.unitPrice) {
            setMessage("All star marked field required!");
            return false;
        }
        return true;
    }

    return (
        <>
            <Row className="justify-content-center">
                <Col md={12}>
                    {isLoader && <ProgressLoader />}
                    {message && (
                        <Alert variant='danger'>
                            {message}
                        </Alert>
                    )}
                    <Form onSubmit={handleSubmit} noValidate>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">Item Date:*</Form.Label>
                            <Col sm="9">
                                <DatePicker
                                    selected={invoiceItem.itemDate}
                                    onSelect={setItemDate}
                                    dateFormat={ddMMyyyy}
                                    className="form-control" />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">Challan No:*</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    maxLength={10}
                                    name='challanNo'
                                    value={invoiceItem.challanNo}
                                    onChange={handleChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">Item Name:*</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    maxLength={100}
                                    name='itemName'
                                    value={invoiceItem.itemName}
                                    onChange={handleChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">HSN Code:</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    maxLength={10}
                                    name='hsnCode'
                                    value={invoiceItem.hsnCode}
                                    onChange={handleChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">Quantity:*</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    maxLength={5}
                                    name='quantity'
                                    value={invoiceItem.quantity}
                                    onChange={handleChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">Unit Price:*</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    maxLength={5}
                                    name='unitPrice'
                                    value={invoiceItem.unitPrice}
                                    onChange={handleChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">Item Amount:</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    maxLength={10}
                                    name='itemAmount'
                                    value={invoiceItem.itemAmount}
                                    onChange={handleChange}
                                    disabled={true} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Col sm={{ span: 9, offset: 3 }}>
                                <Button type="submit" variant='primary' className='mw-100'>
                                    <BiPlus size={20} /> {isEditForm ? 'Update' : 'Add'}
                                </Button>
                                <Button
                                    type="button"
                                    variant='secondary'
                                    className='ms-3 mw-100'
                                    onClick={onCancel}>
                                    <BsX size={20} /> Cancel
                                </Button>
                            </Col>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </>
    )
}

export default InvoiceItemForm;